import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';
import { SessionService } from '../../../features/session.service';
import { TipoUsuario } from '../../../core/enums/tipoUsuario.enum';
import { filter } from 'rxjs';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, RouterModule],
    template: `<ul class="flex flex-col gap-5 p-2 mt-7">
      <ng-container *ngFor="let group of model">
        <ng-container *ngFor="let item of group.items">
          <li
            class="menu-item group relative flex items-center justify-between gap-3
                  overflow-hidden rounded-md
                  bg-[#f1f5f9]
                  px-3 py-2 text-[15px] cursor-pointer
                  transition-all duration-300
                  hover:bg-[var(--p-button-primary-background)] hover:pr-10"
            [routerLink]="item.routerLink || null"
            routerLinkActive="menu-item-active"
            [routerLinkActiveOptions]="{ exact: true }"
            (click)="item.command && item.command({ originalEvent: $event, item: item })"
          >

            <!-- TEXTO -->
            <span
              class="menu-text whitespace-nowrap transition-colors duration-300"
            >
              {{ item.label }}
            </span>

            <!-- ÍCONE -->
            <i
                class="{{ item.icon }}
                      menu-icon
                      transition-all duration-300
                      text-[var(--p-primary-color)]
                      group-hover:text-[var(--p-primary-contrast-color)]
                      group-hover:translate-x-10
                      group-hover:opacity-0"
              ></i>
          </li>
        </ng-container>
      </ng-container>
    </ul>
    `
})
export class AppMenu {
  private sessionService = inject(SessionService);
  private authService = inject(SessionService);

  model: MenuItem[] = [];

  ngOnInit() {
  this.sessionService.usuario$
    .pipe(filter(u => !!u))
    .subscribe(usuario => {
      this.montarMenu(
        usuario!.isnUsuarioTipo,
      );
    });
}


  requiresFornecedor?: boolean;

  onMenuClick(item: any) {
    if (item.command) {
      item.command();
    }
  }


  logout() {
    this.authService.logout();
  }

  filtrarPorPerfil(menu: any[], tipoUsuario: TipoUsuario): any[] {
  return menu
    .map(item => {
      if (item.items) {
        const filhos = item.items.filter((sub: any) =>
          !sub.roles || sub.roles.includes(tipoUsuario)
        );
        return { ...item, items: filhos };
      }
      return item;
    })
    .filter(item => !item.roles || item.roles.includes(tipoUsuario));
}

  filtrarMenu(
    menu: any[],
    tipoUsuario: TipoUsuario,
  ): any[] {

    return menu
      .map(group => {
        if (!group.items) return group;

        const itemsFiltrados = group.items.filter((item: any) => {
          const perfilOk = !item.roles || item.roles.includes(tipoUsuario);

          if (!perfilOk) return false;

          // 🎯 REGRA DOS DASHBOARDS PF / PJ
          if (item.routerLink?.[0] === '/pages/dashboard') {
            return this.sessionService.isFornecedorBasico();
          }

          if (item.routerLink?.[0] === '/pages/dashboardFornecedor') {
            return this.sessionService.isFornecedorCompleto();
          }

          // Demais menus continuam usando requiresFornecedor
          if (item.requiresFornecedor === true) {
            return this.sessionService.isFornecedorValido();
          }

          return true;
        });

        return { ...group, items: itemsFiltrados };
      })
      .filter(group => group.items.length > 0);
  }


  montarMenu(tipoUsuario: TipoUsuario) {

    const menuBase: any[] = [
      {
        // label: 'Home',
        items: [
          { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/pages/dashboard'], roles:[TipoUsuario.FPF, TipoUsuario.FPJ ], requiresFornecedor: false },
          { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/pages/dashboardFornecedor'], roles:[TipoUsuario.FPF, TipoUsuario.FPJ ], requiresFornecedor: true },
          { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/pages/dashboardAreaInteresse'], roles:[TipoUsuario.ADA], requiresFornecedor: false },
          { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/pages/dashboardValidador'], roles:[TipoUsuario.ADV], requiresFornecedor: false },
          { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/pages/dashboardADM'], roles:[TipoUsuario.ADM], requiresFornecedor: false },
        ]
      },
      {
        // label: 'Meu Cadastro', roles: [TipoUsuario.FPJ, TipoUsuario.FPF],
        items: [
          { label: 'CPF', icon: 'pi pi-fw pi-user', routerLink: ['/pages/cadastroPessoaFisica'], roles:[TipoUsuario.FPF], requiresFornecedor: false },
          { label: 'CNPJ', icon: 'pi pi-fw pi-building', routerLink: ['/pages/cadastroCnpj'], roles:[TipoUsuario.FPJ], requiresFornecedor: false },
        ]
      },
      {
        // label: 'Meus Documentos', roles: [TipoUsuario.FPJ, TipoUsuario.FPF, TipoUsuario.ADV, TipoUsuario.ADM],
        items:[
          { label: 'Gestão de Documentos', icon: 'pi pi-fw pi-file-o', routerLink: ['/pages/gestaoDeDocumentosFornecedor'], roles:[TipoUsuario.FPF, TipoUsuario.FPJ], requiresFornecedor: true },
          { label: 'Gestão de Documentos', icon: 'pi pi-fw pi-file-o', routerLink: ['/pages/documentos'], roles:[TipoUsuario.ADM, TipoUsuario.ADV] }
        ]
      },
      {
        // label: 'Modulo de validação' ,roles:[TipoUsuario.ADV, TipoUsuario.ADM],
        items:[
          { label: 'Validar CNPJ/CPF', icon: 'pi pi-fw pi-file-o', routerLink: ['/pages/validador'], roles:[TipoUsuario.ADV, TipoUsuario.ADM] },
          { label: 'Validar Documentação', icon: 'pi pi-fw pi-file-o', routerLink: ['/pages/gestaoDocumentosValidador'], roles:[TipoUsuario.ADV, TipoUsuario.ADM] },
        ]
      },
      {
        // label: 'Modulo de Agendamento' ,roles:[TipoUsuario.FPF, TipoUsuario.FPJ],
        items:[
          { label: 'Agendamento de visitas', icon: 'pi pi-fw pi-calendar-minus', routerLink: ['/pages/agendamentoLista'], roles:[TipoUsuario.FPF, TipoUsuario.FPJ], requiresFornecedor: true },
          // { label: 'Cadastro de Agendamento', icon: 'pi pi-fw pi-file-o', routerLink: ['/pages/agendarVisita'], roles:[TipoUsuario.FPF, TipoUsuario.FPJ] },
        ]
      },
      {
        // label: 'Modulo de Agendamento' ,roles:[TipoUsuario.ADA, TipoUsuario.ADM],
        items:[
          { label: 'Agendamento de visitas', icon: 'pi pi-fw pi-calendar-minus', routerLink: ['/pages/agendamentosSolicitados'], roles:[TipoUsuario.ADA, TipoUsuario.ADM] },
        ]
      }
    ];
    this.model = this.filtrarMenu(menuBase, tipoUsuario);
  }
}
